/**
 * These files have been moved into separate files to fix an issue with the Storybook build.
 * The Storybook build is crashing when it encounters the server `cookie` and `http` packages import.
 * This means we'll need to import the files separately if a component needs to work with Storybook.
 */

export { getSegmentFromClient } from './getSegmentClient';
export { getSegmentFromServer } from './getSegmentServer';
export { getSegmentFromLocale } from './getSegmentFromLocale';
